import { CandidateEmailComponent } from './../../candidate/candidate-email/candidate-email.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TalentpoolService } from './../../_services/talentpool.service';
import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { CreateTalentpoolComponent } from '../create-talentpool/create-talentpool.component';
import { TransactionService } from '../../_services/transaction.service';
import { Router } from '@angular/router';

declare const clevertap;


@Component({
  selector: 'app-add-to-talentpool',
  templateUrl: './add-to-talentpool.component.html',
  styleUrls: ['./add-to-talentpool.component.scss']
})
export class AddToTalentpoolComponent implements OnInit {

  talentpoolslist: any[] = [];
  talentpoolname: string = '';
  confirmation_message: string;
  talentpoolnumber: any;
  success_message: string;
  noTalentpoolError: boolean;
  subscriptiondetails: any = {};

  @Input() candidatetoAdd: any;
  @Input() BuldCandidatetoAdd: any[];
  @Input() type;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  @Input() calledFrom: String = ''
  @Input() profileurlsarray: any = [];
  @ViewChild('confirmationModal') confirmationModal: TemplateRef<any>
  @ViewChild('errorModal') errorModal: TemplateRef<any>
  @ViewChild('successModal') successModal: TemplateRef<any>
  @ViewChild('noCreditTalentpool') noCreditTalentpool: TemplateRef<any>;
  errorMessage: any;

  @ViewChild('trigger') matAutocompleteTrigger: any;
  
  @ViewChild('requestCredit') requestCredit: TemplateRef<any>;

  @Input() uiChange: any = false;
  talentpools: any
  talentpoolerrormsg: string = '';
  addToTalentpoolSpinner: boolean = false;
  hideCreateTalentpool: boolean = false;
  
  constructor(private router: Router,public talentpoolservice: TalentpoolService, public modalService: NgbModal,
    private _localstorageservice : LocalStorageService,
    private candidateService : CandidateService,
    private transactionservice: TransactionService
    ) { }

  ngOnInit() {
    this.getAllTalentpool();
  }

  async getAllTalentpool(event = null){
    const result = await this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).toPromise();
    const talentPoolData = result.status == "success" ? result.data : result;
    this._localstorageservice.setItem('talentPoolDetails', JSON.stringify(talentPoolData));
    if (talentPoolData && Object.keys(talentPoolData).length) {
        this.talentpoolslist = talentPoolData.talentpools.filter((x) =>{ return x.name.toLowerCase().includes(this.talentpoolname.toLowerCase()) });
        this.talentpools = this.talentpoolslist;
        let talentpoolFound =  talentPoolData.talentpools.find(x => (x.name == this.talentpoolname));
        if(talentpoolFound == undefined && this.talentpoolname!= ''){
          if(this.calledFrom == 'searchToolBox' && event){
            this.talentpoolslist = []
            this.talentpoolslist.push({
              name: event.target.value,
              notFound: true
            })
          }
        }else{
          this.noTalentpoolError = false
        }
     }
  }

  openConfirmationModal() {
    this.talentpoolerrormsg = '';
    if(this.talentpoolname != '' && this.talentpoolname != null && this.talentpoolname && this.talentpoolname.trim() != '') {
      this.confirmation_message = 'Are you sure you want to add selected candidates to ' + this.talentpoolname + '? ';
      const dialogRef = this.modalService.open(this.confirmationModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    } else {
      this.talentpoolerrormsg = 'Enter talentpool name';
    }
     
    
  }


  addCandidateToTalentpool() {
      let candidateobject = [];
      for (let candidate of this.BuldCandidatetoAdd) {
        candidateobject.push({
          candidatenumber: candidate
        })
      }

    let data = {
        talentpoolnumber: this.talentpoolnumber,
        insertobject: candidateobject.length > 0 ? candidateobject :  [{'candidatenumber' :  this.candidatetoAdd.candidatenumber }],
        usernumber: this._localstorageservice.getItem('usernumber')
      }

    this.addToTalentpoolSpinner = true;
    this.talentpoolservice.addCandidatetoTalentpool(data).subscribe((res: any) => {
      this.addToTalentpoolSpinner = false;
      if (res.status == 'success' && res.message != 'Nothing to insert') {
        this.modalService.dismissAll()
        this.passEntry.emit('candidateAdded');
      }else if(res.message =='Nothing to insert') {
        this.modalService.dismissAll()
        this.passEntry.emit('alreadyexist');
      }else if(res.message =='Missing parameters') {
        this.modalService.dismissAll()
        this.passEntry.emit('Missing parameters');
      }else {
        this.modalService.dismissAll()
        this.passEntry.emit('error');
      }
    })
  }

  openCreateTalentpool(event, talentpoolData){
    this.talentpoolerrormsg = '';
    const data = {
      name: talentpoolData.name,
      usernumber: this._localstorageservice.getItem('usernumber')
    }
    if(this._localstorageservice.getItem('tpcredits') > -1){
      this.talentpoolservice.createTalentpool(data).subscribe((result: any) => {
        if(result.status == 'success'){
          this.toastmessage('Talentpool Created Succesfully', 'success')
          if(this.matAutocompleteTrigger){
            this.matAutocompleteTrigger.closePanel()
          }
          this.fetchcredits()
          const data = {
            profileurlsarray: this.profileurlsarray,
            talentpoolnumber: result.data.talentpoolnumber,
            talentpoolname: talentpoolData.name
    
          }
          this.talentpoolnumber = result.data.talentpoolnumber
          this.passEntry.emit(data)
        }else if (result.status == 'failure' && result.message == 'insufficient credits') {
          this.modalService.dismissAll();
          const modalRef = this.modalService.open(this.noCreditTalentpool,{ centered: true });
          this.sendmailexpiry('Talent Pipeline credits')
        }
      });
    }else{
      let clevertap_data = {
        "Talent Pool Name" : 'null',
      }
      this.cleverTapEvent("TalentPool_CreditExpiry", clevertap_data);
      const modalRef = this.modalService.open(this.noCreditTalentpool,{ centered: true });
      this.sendmailexpiry('Talent Pipeline credits')
    }
    return event.stopPropagation();
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.success_message = message;
      setTimeout(() => this.success_message = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  fetchcredits() {
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
        } else {
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            // this.isteamMember = true
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
          }
        }
        this.subscriptiondetails.smartemailcredits = res.data.smartemailcredits
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits)
      }
    })
  }
  sendmailexpiry(type){
    let data ={
      expiredmetric : type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }

  route2pricing() {
    this.modalService.dismissAll()
    if(this._localstorageservice.getItem('isteamMember')){
      this.modalService.open(this.requestCredit, { windowClass: "modalExtract",  centered: true, backdrop: 'static', keyboard: false });
    }else{
      this.router.navigateByUrl('subscription/pricing')
    }
  }

  searchtalentpool(event) {
    this.hideCreateTalentpool  = false
    this.talentpoolerrormsg = '';
    const value = event.target.value;
    this.talentpools = this.talentpoolslist.filter((x) =>{ return x.name.toLowerCase().includes(value.toLowerCase()) });
    if(value !== ''){
      this.talentpools.push({
        name: event.target.value,
        userAdded: true
      })
    }    
    if(this.talentpools && this.talentpools.length && this.talentpools[0].name.trim().toLowerCase() == value.trim().toLowerCase() && this.talentpools[0].hasOwnProperty('talentpoolnumber')){
      this.hideCreateTalentpool = true;
      this.talentpools = this.talentpools.filter(x => !x.userAdded === true)
    }
   
    this.passEntry.emit({ talentpoolname: this.talentpoolname });
  }

  selecttalentpool(talentpool) {
    this.talentpoolerrormsg = '';
    if(this.calledFrom == 'searchToolBox'){
      const data = {
        profileurlsarray: this.profileurlsarray,
        talentpoolnumber: talentpool.talentpoolnumber,
        talentpoolname: talentpool.name

      }
      this.passEntry.emit(data)
    }
    this.talentpoolnumber = talentpool.talentpoolnumber
  }
}
